export const POPOVER_TYPES = {
  SEARCH: 'SEARCH',
  FILTERS: 'FILTERS',
}
